import { motion } from "framer-motion";
import Seo from "../components/Seo";
import AsmStory from "../components/AsmStory";
import WorkflowSection from "../components/WorkflowSection";
import ResourcesSection from "../components/ResourcesSection";
import { BOOK_DEMO_URL } from "../lib/constants";

export default function Asm() {
  return (
    <main className="flex-grow">
      <Seo
        title="Attack Surface Intelligence"
        description="Every asset discovered, scored, and monitored — including exposed logins without MFA. See your real attack surface before an attacker finds it first."
        path="/asm"
      />

      <section className="relative pt-16 md:pt-section-gap pb-section-gap px-margin-mobile md:px-gutter max-w-container-max mx-auto overflow-hidden">
        <div className="absolute inset-0 bg-glow-orange opacity-50 pointer-events-none" />
        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <p className="font-eyebrow text-eyebrow text-primary-container mb-stack-md uppercase tracking-widest">
            Module 1
          </p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-display-hero-mobile text-display-hero-mobile md:font-display-hero md:text-display-hero text-on-surface dark:text-surface-bright mb-stack-lg"
          >
            Attack Surface Intelligence
          </motion.h1>
          <p className="font-body-lg text-body-lg text-on-surface-variant dark:text-surface-variant mb-16 max-w-2xl mx-auto">
            Every asset discovered, scored, and monitored. See your real attack surface before an
            attacker finds it first.
          </p>
        </div>
      </section>

      <AsmStory />
      <WorkflowSection />

      <ResourcesSection
        moduleKey="asm"
        contained
        eyebrowColor="text-primary"
        heading="Take the case to your team"
        subhead="The one-page flyer for a quick share, or the full coverage document for the follow-up conversation."
      />

      <section className="text-center py-section-gap px-gutter">
        <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright mb-stack-lg">
          See your real attack surface.
        </h2>
        <a
          href={BOOK_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center bg-primary-container text-on-primary-container font-headline-card px-8 py-4 rounded-DEFAULT hover:scale-105 transition-transform shadow-sm font-semibold"
        >
          Book a Demo
        </a>
      </section>
    </main>
  );
}
